export type Testimonio = {
  quote: string
  author: string
  role?: string
  city?: string
  photo?: string
}

/** Tanda 1: resultado económico, crisis resuelta y cambio de estatus. */
export const testimoniosTanda1: Testimonio[] = [
  {
    quote:
      'Antes cotizaba a ojo y cuando me decían "uy, qué caro" bajaba el precio en el momento. Con la estructura de costos del Tomo 2 armé el presupuesto con el fee aparte y lo presenté sin pedir disculpas. Pasé de cobrar 400 dólares con todo mezclado a 950 con mi fee de dirección desglosado en el mismo tipo de fiesta. La mamá no discutió el número, me preguntó por la fecha.',
    author: 'Daniela Restrepo',
    role: 'Organizadora de eventos',
    city: 'Medellín, Colombia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/d9115524-102b-4516-913f-4609143359a8.jpg',
  },
  {
    quote:
      'El DJ me falló a cuatro horas del evento. Antes me habría muerto. Tenía el protocolo del Tomo 6 y los contactos del Tomo 5, lo resolví en treinta y cinco minutos y dos llamadas, y la familia nunca se enteró de que hubo un problema.',
    author: 'Mariana Cordero',
    role: 'XV Planner',
    city: 'Guadalajara, México',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/89682fd8-6f41-4e41-bf36-ad1ecf67929a.jpg',
  },
  {
    quote:
      'Lo que más me sorprendió fue cómo me empezaron a tratar los proveedores. Llegué al montaje con el cronograma impreso y los horarios de ingreso escalonados, y por primera vez me preguntaron a mí a qué hora entraban en lugar de aparecer todos juntos. Uno me dijo: "hace quince años que monto fiestas y es la primera vez que alguien me pasa el horario de ingreso por escrito".',
    author: 'Valeria Ocampo',
    role: 'Directora creativa de eventos',
    city: 'Lima, Perú',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/ddf42e16-97be-423d-94c9-1ed842ed1879.jpg',
  },
]

/** Tanda 2: cada cita nombra un componente específico del sistema. */
export const testimoniosTanda2: Testimonio[] = [
  {
    quote:
      'Fui a ver un salón que me encantaba y con la lista de los 75 puntos encontré que la potencia eléctrica no alcanzaba para sonido, pantallas e iluminación al mismo tiempo: había que contratar un generador aparte. Sin la lista lo firmaba igual. Me habría costado 350 dólares de un generador de urgencia que nadie iba a pagar o directamente arruinaba la fiesta con un apagón en pleno vals. Solo por eso ya valió todo lo demás.',
    author: 'Carolina Bermúdez',
    role: 'Organizadora de quince años',
    city: 'Santo Domingo, República Dominicana',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/4fa6e284-b6a5-4d98-878e-abb885aa0d1a.jpg',
  },
  {
    quote:
      'La diferencia más grande fue cómo llegué al día del evento. En la fiesta anterior no paré ni para comer. Con el minuto a minuto técnico, a las once de la noche yo estaba sentada, comiendo un plato caliente, mirando el ingreso de la quinceañera con el guion en la mano en vez de corriendo atrás del DJ. Es la primera vez que disfruté algo que armé yo.',
    author: 'Andrea Villalobos',
    role: 'XV Planner y productora',
    city: 'Ciudad de México, México',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/2d464dcf-ede6-40cc-9212-2ff50b4e5509.jpg',
  },
]
